import React, { useEffect, useState } from 'react';

/**
 * EuropcarGecisDegerlendirme: Europcar Türkiye geçiş değerlendirmesi sunumu.
 * Route: /r/europcar-gecis-degerlendirme (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 36 slayt, 16:9, apple.com tasarım dili. Yeniden üretim:
 * node src/pages/europcar-gecis-degerlendirme/build.js
 *
 * 🔑 "PDF olarak indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P
 * slaytları tek sayfaya kırpar; düğmeyi dışarı taşıma.
 *
 * HTML modülü büyük, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function EuropcarGecisDegerlendirme() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./europcarGecisHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Europcar Türkiye · Geçişten Bugüne"
      srcDoc={html}
      style={fill}
    />
  );
}
